var _ellipse, _ellipse2, _path, _path2, _path3;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgLeaf(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 81,
    height: 49,
    viewBox: "0 0 81 49",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _ellipse || (_ellipse = /*#__PURE__*/React.createElement("ellipse", {
    opacity: 0.1,
    cx: 26.2601,
    cy: 44.0068,
    rx: 22.9845,
    ry: 4.99394,
    fill: "#042A44"
  })), _ellipse2 || (_ellipse2 = /*#__PURE__*/React.createElement("ellipse", {
    opacity: 0.1,
    cx: 71.166,
    cy: 40.3326,
    rx: 5.02217,
    ry: 1.31983,
    fill: "#042A44"
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M70.9084 39.6838C69.6188 39.1528 67.8134 37.135 70.9084 33.3118C74.0033 29.4886 74.7771 25.3468 74.7771 23.7538",
    stroke: "#1D5B3D",
    strokeWidth: 2
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M50.2129 0.01196C70.6246 -0.422354 75.7276 11.0343 76.3399 15.9331C76.5675 17.7537 64.7212 16.9722 57.8031 17.1542C49.1554 17.3818 21.3917 44.4628 14.5646 44.4628C9.10285 44.4628 1.97228 42.9456 0 41.7319C2.57914 41.2009 7.33151 40.5266 12.247 37.9778C18.3915 34.7918 22.0447 30.6333 27.3517 19.6072C29.0118 16.1583 32.6588 8.99312 37.1494 6.13548L43.2729 6.95195L39.1905 4.28975C42.4483 1.78945 46.1614 0.0981667 50.2129 0.01196Z",
    fill: "#1D5B3D"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M13.4717 44.9178C6.9177 44.9178 2.50315 43.3249 0.910156 41.9595C5.99258 41.3526 10.6957 41.9595 19.571 38.0908C29.266 33.8647 35.501 22.7223 39.8248 18.7472C53.9343 5.77568 65.9955 9.64439 70.7745 10.5547C75.5535 11.4649 81.0152 16.244 79.8773 22.1608C79.1686 25.8464 74.667 27.772 73.074 27.772C74.707 22.4649 67.8161 20.5678 61.2165 20.3402C54.6169 20.1126 48.8284 24.7996 42.4564 31.8543C39.1676 35.4955 27.76 44.9178 13.4717 44.9178Z",
    fill: "#3A8761"
  })));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgLeaf);
export default __webpack_public_path__ + "static/media/leaf.09c6cffd90fd8994d9591354c50f4f9f.svg";
export { ForwardRef as ReactComponent };